import type { InventoryResource } from '@repo/api-gw-sdk';

import ConfirmationDialog from '@/components/dialogs/confirmationDialog';
import { useDAL } from '@/contexts/useDAL';

export function RestartApplicationDetection({
  open,
  onClose,
  entities,
}: {
  open: boolean;
  onClose: () => void;
  entities: InventoryResource[];
}) {
  const dal = useDAL();

  const onSave = () => {
    void dal.inventory.apps
      .deleteOverride(entities)
      .then(() => {
        for (const entity of entities) {
          entity.classifications = entity.classifications || {};
          entity.classifications.appsDetails =
            entity.classifications.appsDetails || {};
          entity.classifications.appsDetails.apps = [];
          entity.classifications.appsDetails.isOverridden = false;
        }
      })
      .finally(onClose);
  };

  return (
    <ConfirmationDialog
      isOpen={open}
      title='Resume auto-classification for applications'
      description='Applications will be automatically detected, and your overridden applications will be removed. This could change the applied backup policies and controls.'
      onCancel={onClose}
      onConfirm={onSave}
      buttonTitle='Resume'
      buttonIconClass='material-symbols-motion-play-outline-rounded'
      confirmSnackbarText='Application auto-classification resumed.'
    />
  );
}
